<template>
    <div class="my-2">
        <v-toolbar flat color="white">
            <v-btn color="primary" round class="white--text" @click="addRegionModal=true, item.modalType='Add'">Add Region</v-btn>
            <v-spacer></v-spacer>
            
            <v-text-field label="Search" clearable v-model="search"></v-text-field>
        </v-toolbar>
        <v-data-table :items="regions" :headers="headers" :search="search">
             <template v-slot:items="props">
                 <td>
                     <v-layout justify-center align-center>
                         <v-icon @click="item=props.item, item.modalType='Edit', addRegionModal=true">edit</v-icon>
                         <v-icon>delete</v-icon>
                     </v-layout>
                 </td>
                 <td class="text-xs-center">{{props.item.name}}</td>

            </template>
        </v-data-table>
        <v-dialog v-model="addRegionModal" persistent width="750px">
            <v-card flat color="white">
                <v-toolbar flat color="primary">
                    <h3 class="title white--text">{{item.modalType}} Region</h3>
                    <v-spacer></v-spacer>
                    <v-btn flat color="white" @click="item={}, addRegionModal=false">X</v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout justify-center>
                        <v-flex xs4 mx-1>
                            <v-text-field label="Name" v-model="item.name"></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-layout justify-center>
                        <v-btn v-if="item.modalType=='Add'&&item.name" round class="white--text" color="primary" @click="saveNewRegion(item)">Create</v-btn>
                        <v-btn v-else-if="item.modalType=='Add'" round disabled>Create</v-btn>
                        <v-btn v-else-if="item.modalType=='Edit'" round class="white--text" color="primary" @click="updateRegion(item)">Save</v-btn>

                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Api from '../services/Api'
export default {
    data(){
        return {
            addRegionModal: false,
            item: {},
            key: 0,
            regions: [],
            search: '',
            headers: [
                {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        }
            ]
        }
    },
    created(){
        this.initialize()
    },
    methods: {
        initialize(){
            this.fetchRegions()
        },
        saveNewRegion(item){
            Api().post('/region', item).then(response=>{
                this.regions.push(response.data)
                this.key+=1
                this.item={}
                this.addRegionModal=false
            })
        },
        updateRegion(item){
            Api().put('/region/'+item.id, item).then(response=>{
                this.fetchRegions()
                this.key+=1
                this.item={}
                this.addRegionModal=false
            })
        },
        fetchRegions(){
            Api().get('/region').then(response=>{
                this.regions= response.data
            })
        }
    }
}
</script>